import { IEvent } from "../Event";
import { IDIService } from "../IDIService";
import { ITypedEvent } from "../TypedEvent";

export interface IAppStateService extends IDIService
{
	get CurrentAppState(): AppState;
	Suspend(): void;
	ReturnFromSuspension(): void;
	EnterLowPowerMode(): void;
	ExitLowPowerMode(): void;

	IsWorkingInWebView(): boolean;
	IsActive(): boolean;
	ReturnedFromSuspension(): boolean;
	IsInBackground(): boolean;
	IsHibernationAllowed(): boolean;
	DisallowHibernation(): void;
	AllowHibernation(): void;
	OnReturnedFromSuspension(): IEvent;
	OnSuspended(): IEvent;
	OnEnterLowPowerMode(): IEvent;
	OnExitLowPowerMode(): IEvent;
	OnBackButtonPressed(): IEvent;
	OnForwardButtonPressed(): IEvent;
	OnAppStateChanged(): ITypedEvent<AppState>;
}

export enum AppState
{
	/// <summary>
	/// The app is running in the background. It is not visible to the user (eg. hidden behind another app or minimized).
	/// In this state app should not perform any heavy operations. It can be disconnected from the server.
	/// The app should show that it is inactive and disconnected from the controller.
	/// </summary>
	Suspended = 1,
	/// <summary>
	/// The app returnet brom background and is running in the foreground. It is visible to the user.
	/// In this state app can perform any operations.
	/// The app should reconnect and loggin again and show that it is active and connected to the controller.
	/// </summary>
	ReturnedFromSuspension = 2,
	/// <summary>
	/// The app is running in low pawer mode. In that mode app should not perform any heavy operations. It can be disconnected from the server.
	/// In this state app should show that it is inactive and disconnected from the controller. (similar to "suspended" state but with lower power consumption in mind and can be entered manually and is not depended on app visibility to the user.)
	/// </summary>
	EnteredLowPowerMode = 3,
	/// <summary>
	/// The app returned from low power mode and is running in normal mode. It can perform any operations.
	/// In this state app should reconnect and loggin again and show that it is active and connected to the controller. (similar to "returned from suspension" state and can be entered manually and is not depended on app visibility to the user.)
	/// </summary>
	ExitedLowPowerMode = 4,
	/// <summary>
	/// App session is active. User is logged in and connected to the controller.
	/// App can perform any operations on controller in the context of the user.
	/// </summary>
	LoggedIn = 5,
	/// <summary>
	/// App session is inactive. User is logged out.
	/// The app should show that the user is logged out. it can be still conncecet to the controller. 
	/// This can happen for example, when user is logged out from another device.
	/// </summary>
	LoggedOut = 6,
	/// <summary>
	/// App is connected to the controller.
	/// The app should show that it is connected to the controller and can (or will in a second) login to the controller.
	/// </summary>
	Connected = 7,
	/// <summary>
	/// App is disconnected from the controller and logged out.
	/// The app should show that it is disconnected from the controller and logged out.
	/// </summary>
	Disconnected = 8,
	/// <summary>
	/// App failed to connect to the controller.
	/// The app should show that it is disconnected from the controller and logged out and cannot connect to the controller.
	/// </summary>
	FailedToConnect = 9,
	/// <summary>
	/// App is connecting to the controller.
	/// The app should show that it is connecting to the controller.
	/// </summary>
	Connecting = 10,
	/// <summary>
	/// App is disconnecting from the controller.
	/// The app should show that it is disconnecting from the controller.
	/// </summary>
	Disconnecting = 11,
	/// <summary>
	/// App is reconnecting to the controller.
	/// The app should show that it is reconnecting to the controller.
	/// </summary>
	Reconnecting = 12,
}